import { TEAM_LEVEL_DESCRIPTIONS, TEAM_LEVEL_LABELS, type TeamLevel, type TeamMember } from '@easyhelp/shared';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { TeamMemberItem, type TeamMemberItemProps } from './TeamMemberItem';

export interface TeamGroupCardProps extends Omit<TeamMemberItemProps, 'member'> {
  level: TeamLevel;
  members: TeamMember[];
  onAdd: (level: TeamLevel) => void;
}

/** Un livello del team: nome e compito del gruppo, elenco dei membri, aggiunta. */
export function TeamGroupCard({
  level,
  members,
  onAdd,
  onEdit,
  onMove,
  onRevokeSessions,
  onRemove,
  mcp,
}: TeamGroupCardProps) {
  const headingId = `team-group-${level}`;
  return (
    <Paper component="section" variant="outlined" aria-labelledby={headingId} sx={{ p: 4 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={3}
        justifyContent="space-between"
        alignItems={{ sm: 'flex-start' }}
      >
        <Stack spacing={0.5}>
          <Typography id={headingId} variant="h6" component="h3">
            {TEAM_LEVEL_LABELS[level]}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {TEAM_LEVEL_DESCRIPTIONS[level]}
          </Typography>
        </Stack>
        <Button startIcon={<AddIcon />} variant="outlined" onClick={() => onAdd(level)} sx={{ flexShrink: 0 }}>
          Aggiungi
        </Button>
      </Stack>
      {members.length === 0 ? (
        <Typography color="text.secondary" sx={{ mt: 4 }}>
          Nessuna persona in questo livello: aggiungine una per poterle assegnare un ticket.
        </Typography>
      ) : (
        <List disablePadding sx={{ mt: 3 }}>
          {members.map((member) => (
            <TeamMemberItem
              key={member.id}
              member={member}
              onEdit={onEdit}
              onMove={onMove}
              onRevokeSessions={onRevokeSessions}
              onRemove={onRemove}
              mcp={mcp}
            />
          ))}
        </List>
      )}
    </Paper>
  );
}
